import { Reveal, Overline } from "./Reveal";

const IMG = "https://images.unsplash.com/photo-1641477176034-1a3e10c343a8";

export const Standard = ({ t }) => (
  <section
    id="standard"
    data-testid="standard-section"
    className="relative z-10 py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal>
        <div className="relative">
          <img
            src={IMG}
            alt="Wax seal stamp on paper"
            className="w-full h-[420px] md:h-[540px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-transparent to-black/50" />
          <div className="absolute bottom-6 left-6 right-6 backdrop-blur-md bg-black/50 border border-white/10 p-6">
            <p className="font-display text-2xl gold-text">Sa.Eko® Standard</p>
            <p className="text-white/50 text-sm mt-1">
              Internal certification methodology
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <Overline testId="standard-overline">{t.standard.overline}</Overline>
        <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight">
          {t.standard.title}
        </h2>
        <p className="text-white/60 text-lg leading-relaxed mt-8">
          {t.standard.text}
        </p>

        <div className="mt-12 space-y-px bg-white/10">
          {t.standard.steps.map((s, i) => (
            <div
              key={i}
              className="group flex items-start gap-6 bg-[#0a0a0a] p-6 hover:bg-[#111] transition-colors duration-400"
            >
              <span className="font-display text-3xl text-[#D4AF37]/70 group-hover:text-[#D4AF37] transition-colors">
                {s.no}
              </span>
              <div>
                <h3 className="text-xl font-medium mb-1">{s.title}</h3>
                <p className="text-white/50">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
